(function () {
  const initProduct = (root) => {
    const select = root.querySelector("[data-variant-select]");
    const variantsJson = root.querySelector("[data-product-variants-json]");

    if (!select || !variantsJson) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (error) {
      return;
    }

    const productRoot = root.closest(".roshi-product") || document;
    const form = root.querySelector("form");
    const quantityInput = root.querySelector("[name='quantity']");
    const variantsById = new Map(variants.map((variant) => [String(variant.id), variant]));
    const optionGroups = [...root.querySelectorAll("[data-option-group]")];
    const currentPrice = root.querySelector("[data-product-price-current]");
    const comparePrice = root.querySelector("[data-product-price-compare]");
    const sku = root.querySelector("[data-product-sku]");
    const skuValue = sku ? sku.querySelector("span") : null;
    const addButton = root.querySelector("[data-add-to-cart-button]");
    const addLabel = addButton ? addButton.dataset.addToCartLabel : "";
    const soldOutLabel = addButton ? addButton.dataset.soldOutLabel : "";
    const payment = root.querySelector(".roshi-product-payment");
    const availability = root.querySelector("[data-product-availability]");
    const availableLabel = availability ? availability.dataset.availableLabel : "";
    const availabilitySoldOutLabel = availability ? availability.dataset.soldOutLabel : soldOutLabel;

    let selectedVariants = [];

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents);
      }

      const sample = variants[0]?.price || "";
      const amount = (cents / 100).toFixed(2);
      const prefix = sample.match(/^[^\d-]*/)?.[0] || "";
      const suffix = sample.match(/[^\d.,\s]+$/)?.[0] || "";

      if (prefix) return `${prefix}${amount}`;
      if (suffix) return `${amount} ${suffix}`;
      return amount;
    };

    const groupIsMultiple = (group) => group.dataset.optionMultiple === "true";

    const getSelectedValuesByIndex = () =>
      optionGroups.map((group) => {
        const inputs = [...group.querySelectorAll("[data-option-value]")];
        if (groupIsMultiple(group)) return inputs.filter((input) => input.checked).map((input) => input.value);

        const checked = inputs.find((input) => input.checked);
        return checked ? [checked.value] : [];
      });

    const getAllValuesByIndex = () =>
      optionGroups.map((group) => [...group.querySelectorAll("[data-option-value]")].map((input) => input.value));

    const combinationsFromValues = (valuesByIndex) => {
      if (valuesByIndex.some((values) => values.length === 0)) return [];

      return valuesByIndex.reduce(
        (combinations, values) => combinations.flatMap((combination) => values.map((value) => [...combination, value])),
        [[]]
      );
    };

    const variantForOptions = (options) =>
      variants.find((variant) =>
        variant.options.length === options.length &&
        variant.options.every((option, index) => option === options[index])
      );

    const variantsForValues = (valuesByIndex) =>
      combinationsFromValues(valuesByIndex)
        .map(variantForOptions)
        .filter(Boolean);

    const getSelectedVariants = () => variantsForValues(getSelectedValuesByIndex());

    const setCheckedOptions = (variant) => {
      if (!variant || !Array.isArray(variant.options)) return;

      optionGroups.forEach((group, index) => {
        const inputs = [...group.querySelectorAll("[data-option-value]")];
        const input = inputs.find((item) => item.value === variant.options[index]);

        if (!input) return;

        if (groupIsMultiple(group)) {
          const hasChecked = inputs.some((item) => item.checked);
          if (!hasChecked) input.checked = true;
        } else {
          input.checked = true;
        }
      });
    };

    const updateOptionAvailability = () => {
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll("[data-option-value]").forEach((input) => {
          const exists = variants.some((variant) => variant.options[groupIndex] === input.value);
          const hasAvailableStock = variants.some((variant) => variant.available && variant.options[groupIndex] === input.value);
          const isSelectable = exists && hasAvailableStock;
          const label = input.labels ? input.labels[0] : null;

          input.disabled = !isSelectable;
          if (label) {
            label.classList.toggle("is-unavailable", !isSelectable);
            label.classList.remove("is-sold-out");
          }
        });
      });
    };

    const mediaForVariant = (variant) => {
      if (!variant || !variant.featured_media_id) return;

      const mediaInput = productRoot.querySelector(`[data-product-media-id="${variant.featured_media_id}"]`);
      if (mediaInput) mediaInput.checked = true;
    };

    const variantForInput = (input) => {
      const index = Number(input.dataset.optionIndex);
      const values = getSelectedValuesByIndex();
      values[index] = [input.value];
      const exactVariants = variantsForValues(values);

      return exactVariants.find((variant) => variant.available) ||
        exactVariants[0] ||
        variants.find((variant) => variant.options[index] === input.value && variant.available) ||
        variants.find((variant) => variant.options[index] === input.value);
    };

    const updateSummary = (displayVariant, updateUrl = true) => {
      selectedVariants = getSelectedVariants();
      const primaryVariant = displayVariant || selectedVariants[0] || variantsById.get(select.value);
      const selectedCount = selectedVariants.length;

      if (!selectedCount || !primaryVariant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = soldOutLabel;
        }
        if (payment) payment.hidden = true;
        if (availability) availability.textContent = availabilitySoldOutLabel;
        updateOptionAvailability();
        return;
      }

      select.value = String(primaryVariant.id);
      mediaForVariant(primaryVariant);

      const totalPrice = selectedVariants.reduce((sum, variant) => sum + Number(variant.price_cents || 0), 0);
      const totalCompare = selectedVariants.reduce((sum, variant) => {
        const compare = Number(variant.compare_at_price_cents || 0);
        const price = Number(variant.price_cents || 0);
        return sum + (compare > price ? compare : price);
      }, 0);

      if (currentPrice) currentPrice.textContent = selectedCount > 1 ? formatMoney(totalPrice) : primaryVariant.price;

      if (comparePrice) {
        if (totalCompare > totalPrice) {
          comparePrice.textContent = selectedCount > 1 ? formatMoney(totalCompare) : primaryVariant.compare_at_price;
          comparePrice.hidden = false;
        } else {
          comparePrice.textContent = "";
          comparePrice.hidden = true;
        }
      }

      if (sku && skuValue) {
        const selectedSku = selectedVariants.map((variant) => variant.sku || variant.title).filter(Boolean).join(", ");
        skuValue.textContent = selectedSku;
        sku.hidden = !selectedSku;
      }

      const allSelectedAvailable = selectedVariants.every((variant) => variant.available);

      if (addButton) {
        addButton.disabled = !allSelectedAvailable;
        addButton.textContent = allSelectedAvailable ? (selectedCount > 1 ? `${addLabel} (${selectedCount})` : addLabel) : soldOutLabel;
      }

      if (payment) payment.hidden = selectedCount > 1 || !allSelectedAvailable;
      if (availability) availability.textContent = allSelectedAvailable ? availableLabel : availabilitySoldOutLabel;

      updateOptionAvailability();

      if (updateUrl && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", primaryVariant.id);
        window.history.replaceState({}, "", url.toString());
      }
    };

    const syncFromOptions = (changedInput) => {
      const displayVariant = changedInput && changedInput.checked ? variantForInput(changedInput) : null;
      const changedGroup = changedInput?.closest("[data-option-group]");

      if (displayVariant && changedGroup && !groupIsMultiple(changedGroup)) {
        setCheckedOptions(displayVariant);
      }

      updateSummary(displayVariant);
      if (selectedVariants.length > 0) {
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    };

    const variantFromUrl = new URLSearchParams(window.location.search).get("variant");
    if (variantFromUrl && variantsById.has(variantFromUrl)) {
      const variant = variantsById.get(variantFromUrl);
      select.value = variantFromUrl;
      setCheckedOptions(variant);
    } else {
      setCheckedOptions(variantsById.get(select.value));
    }

    optionGroups.forEach((group) => {
      group.addEventListener("change", (event) => {
        if (!event.target.matches("[data-option-value]")) return;
        syncFromOptions(event.target);
      });
    });

    select.addEventListener("change", () => {
      const variant = variantsById.get(select.value);
      setCheckedOptions(variant);
      updateSummary(variant);
    });

    form?.addEventListener("submit", async (event) => {
      const addItems = selectedVariants.filter((variant) => variant.available);
      if (addItems.length <= 1) return;

      event.preventDefault();
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = "Adding...";
      }

      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const rootPath = window.Shopify?.routes?.root || "/";

      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: addItems.map((variant) => ({ id: variant.id, quantity })),
          }),
        });

        if (!response.ok) throw new Error("Add to cart failed");
        window.location.href = `${rootPath}cart`;
      } catch (error) {
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = `${addLabel} (${addItems.length})`;
        }
      }
    });

    updateSummary(variantsById.get(select.value), false);
  };

  const init = () => {
    document.querySelectorAll("[data-roshi-product]").forEach(initProduct);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
